import { categoryMap } from '$lib/global/tracking/integrations';

import type { IntegrationCategory, IntegrationData } from '$lib/components/ConsentOverlay/types';

export const getIntegrationsByCategory = (
    integrations: string[],
    category: IntegrationCategory,
) => {
    const list: string[] = [];

    integrations.forEach((integration) => {
        if (categoryMap[category].includes(integration)) {
            list.push(integration);
        }
    });

    return list;
};

export const getActiveIntegrations = (
    selectedIntegrations: IntegrationData,
    integrationData: IntegrationData,
) => {
    const activeIntegrations: IntegrationData = {};

    Object.keys(selectedIntegrations).forEach((displayName) => {
        const enabled = selectedIntegrations[displayName];

        if (enabled) {
            activeIntegrations[displayName] = integrationData[displayName];
        }
    });

    return activeIntegrations;
};
